import React, { useEffect, useState } from "react";

function Footer({ companyName = "xdata", website = "https://xdata.uz" }) {
	const [time, setTime] = useState("");

	useEffect(() => {
		const interval = setInterval(() => {
			const now = new Date();
			const year = now.getFullYear();
			const hours = String(now.getHours()).padStart(2, "0");
			const minutes = String(now.getMinutes()).padStart(2, "0");
			const seconds = String(now.getSeconds()).padStart(2, "0");

			setTime(`${year} | ${hours}:${minutes}:${seconds}`);
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<footer className="w-full font-mono text-white hidden md:flex text-xxsm justify-center items-center text-center absolute bottom-0 z-50 gap-1">
			<p className="text-gray-200 font-light tracking-wide text-center">
				© {time}{" "}				
				. This platform is designed and developed by{" "}
				<a
					href={website}
					target="_blank"
					rel="noreferrer"
					className="font-medium text-indigo-400 hover:text-indigo-300 transition"
				>
					{companyName}
				</a>
				.
			</p>
		</footer>
	);
}

export default Footer;
